import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Form, Icon, Message } from "semantic-ui-react";
import { Auth } from "../../store/actions/";
import "./SignIn.scss";

type RootState = {
  auth: {
    isAuthenticated: boolean;
    reauthenticating: boolean;
    reauthError: string | null;
    user: { _id: string; email: string } | null;
  };
  config: {
    baseDomain: string;
    port: string;
  };
};

const SignInContainer: React.FC<{ config: any }> = ({ config }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isAuthenticated, reauthenticating, reauthError } = useSelector(
    ({ auth }: RootState) => ({
      isAuthenticated: auth.isAuthenticated,
      reauthenticating: auth.reauthenticating,
      reauthError: auth.reauthError,
    })
  );

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);

  React.useEffect(() => {
    if (isAuthenticated) {
      history.replace("/home");
    }
  }, [isAuthenticated, history]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password || reauthenticating) return;
    dispatch(
      Auth.authReauthApp({
        email,
        password,
        dispatch,
        callbackSuccess: () => {
          history.replace("/home");
        },
      })
    );
  };

  const handleGoToWebsite = () => {
    const { baseDomain, port } = config;
    const websiteUrl = `${baseDomain}${port ? ":3000" : ""}/signin`;
    window.location.replace(websiteUrl);
  };

  if (isAuthenticated) return null;

  return (
    <div className="webapp-signin-page">
      <div className="signin-card">
        <h2>Sign In</h2>
        <p className="signin-subtitle">Sign in to continue to your school</p>

        {reauthError && (
          <Message negative className="signin-error">
            <Message.Header>Sign in failed</Message.Header>
            <p>{reauthError}</p>
          </Message>
        )}

        <Form onSubmit={handleSubmit} loading={reauthenticating}>
          <Form.Input
            label="Email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(_, { value }) => setEmail(value)}
            disabled={reauthenticating}
            required
          />
          <Form.Input
            label="Password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            value={password}
            onChange={(_, { value }) => setPassword(value)}
            disabled={reauthenticating}
            required
            icon={
              <Icon
                name={showPassword ? "eye slash" : "eye"}
                link
                className="signin-eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              />
            }
          />
          <Button
            type="submit"
            fluid
            loading={reauthenticating}
            disabled={!email || !password || reauthenticating}
            className="signin-submit-btn"
          >
            Sign In
          </Button>
        </Form>

        <hr className="signin-divider" />

        <button className="signin-website-link" onClick={handleGoToWebsite}>
          Go to Website
        </button>
      </div>
    </div>
  );
};

export default SignInContainer;
